/**
 * Human label for orders from Distru (placedfrom + order_channel).
 */
export function orderChannelSourceLabel(row: {
	placedfrom?: string | number;
	order_channel?: string;
	details?: { placedfrom?: string | number; order_channel?: string };
}): string | null {
	const ch = String(row?.details?.order_channel ?? row?.order_channel ?? '').toLowerCase();
	if (ch === 'distru') {
		return 'Distru';
	}
	const raw = row?.details?.placedfrom ?? row?.placedfrom;
	const n = parseInt(String(raw ?? ''), 10);
	if (n === 8) {
		return 'Distru';
	}
	return null;
}
